
import { CenterLink as component } from '../../components/editor/CenterLink'

export const CenterLink = {
  label: 'Centered Header Link',
  component,
  fields: [
    {
      name: 'label',
      label: 'Label',
      widget: 'string'
    },
    {
      name: 'href',
      label: 'Link',
      widget: 'string',
      required: false
    },
    {
      name: 'fontsize',
      label: 'Font Size in "rem"',
      widget: 'string',
      default: '1',
      hint: 'You can think of a value of 1 as a normal size. 2 is twice normal size. You can also do something like 3.5 etc.'
    }
  ]
}
